import { useState, createContext, useContext } from 'react';

export const WebsiteContext = createContext(null);

export const useWebsite = () => {
	return useContext(WebsiteContext);
};

export default function WebsiteProvider(props) {
	const [profileOpen, setProfileOpen] = useState(false);
	const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

	const value = {
		profileOpen,
		setProfileOpen,
		mobileMenuOpen,
		setMobileMenuOpen
	};

	return <WebsiteContext.Provider value={value}>{props.children}</WebsiteContext.Provider>;
}